import { type FC, useContext } from "react";
import type { OverlayTriggerState } from "react-stately";
import { DialogComponent, HStack, Modal, TriggerButton, TriggerButtonSize, VStack } from "widgets";
import { useOverlay } from "widgets/hooks";

import { GenomePanel } from "./GenomePanel.tsx";
import { TrackConfigurationContext } from "./TrackConfigurationContext.ts";
import { TrackConfigurationProvider } from "./TrackConfigurationProvider.tsx";
import { TrackPanel } from "./TrackPanel.tsx";
import style from "./TracksConfiguration.module.css";

export const TracksConfigurationDialog = ({ showLabel = false }: { showLabel?: boolean }) => {
  const { overlayProps, state } = useOverlay({});

  return (
    <>
      <TriggerButton
        size={TriggerButtonSize.Normal}
        icon={"settings_panorama"}
        onPress={() => {
          state.open();
        }}
        label={showLabel ? "Tracks" : "Track Configuration"}
        aria-label="Track Configuration"
        showLabel={showLabel}
      />
      <Modal state={state} {...overlayProps}>
        <TrackConfigurationProvider>
          <ConfigDialogContent state={state} />
        </TrackConfigurationProvider>
      </Modal>
    </>
  );
};

interface DialogContentProps {
  state: OverlayTriggerState;
}

const ConfigDialogContent: FC<DialogContentProps> = ({ state }) => {
  const { trackConfiguration, applyChanges } = useContext(TrackConfigurationContext);

  return (
    <DialogComponent
      data-testid="track-configuration"
      contentStyle={{ padding: 0, overflowY: "hidden" }}
      mainButton={{
        label: "Apply",
        onPress: () => {
          applyChanges(trackConfiguration);
          state.close();
        },
      }}
      asPanelHeader
      closeFn={() => {
        state.close();
      }}
      title="Track Configuration"
    >
      <VStack spacing={0}>
        <HStack spacing={0} className={style.trackConfiguration}>
          <GenomePanel />
          <TrackPanel />
        </HStack>
      </VStack>
    </DialogComponent>
  );
};
